import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router';
import { isLanguageSupported } from 'src/modules/locales/utils/isLanguageSupported';
import { useRoute } from 'src/router/hooks/useRoute';

export const LanguageLayout = () => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  const isSupported = lang ? isLanguageSupported(lang) : true;

  useEffect(() => {
    if (!isSupported) {
      navigate(ROUTE[404].get());
    }
  }, []);

  return <Outlet />;
};
